import type { CSSProperties } from 'react';

/** Spacing tokens — 07-11 semantic space aliases */
export const SPACING_TOKENS = [
  'pageGutter',
  'sectionGap',
  'fieldGap',
  'fieldLabelGap',
  'inlineGap',
  'rowPadding',
] as const;

export type SpacingToken = (typeof SPACING_TOKENS)[number];

const SPACING_CSS_VAR: Record<SpacingToken, string> = {
  pageGutter: '--space-page-gutter',
  sectionGap: '--space-section-gap',
  fieldGap: '--space-field-gap',
  fieldLabelGap: '--space-field-label-gap',
  inlineGap: '--space-inline-gap',
  rowPadding: '--space-row-padding',
};

export function spacingVar(token: SpacingToken): string {
  return `var(${SPACING_CSS_VAR[token]})`;
}

export function spacingStyle(token: SpacingToken): CSSProperties {
  if (token === 'rowPadding') {
    return { padding: spacingVar('rowPadding') };
  }
  return { gap: spacingVar(token) };
}

const SPACING_CLASSNAMES: Record<SpacingToken, string> = {
  pageGutter: 'gap-page-gutter',
  sectionGap: 'gap-section',
  fieldGap: 'gap-field',
  fieldLabelGap: 'gap-field-label',
  inlineGap: 'gap-inline',
  rowPadding: 'p-row-padding',
};

export function spacingClassName(token: SpacingToken): string {
  return SPACING_CLASSNAMES[token];
}
